import React from 'react';
import styled from 'styled-components';
import { neutral } from '../../style/colors';

const RadioButtonsHorizontal = (props: IRadioButtonsHorizontalProps) => {
  const { choices, onChange, selectedRadioButton } = props;
  return (
    <Wrapper>
      {choices.map(choice => {
        return (
          <label key={choice.value}>
            <input
              type="radio"
              value={choice.value}
              name={choice.name}
              checked={selectedRadioButton === choice.value}
              onChange={e => onChange(e.target.value)}
            />
            <i></i>
            <span>{choice.title}</span>
          </label>
        );
      })}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  /* justify-content: flex-start; */
  margin: 12px -15px 25px -15px;
  
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    :checked ~ i {
      // border-color: ${neutral[600]};
    }
    :checked ~ i:after {
      display: block;
    }
    :checked ~ span {
      color: #1E4765;
    }
  }

  label {
    font-size: 13px;
    margin-right: 25px;
    display: flex;
    cursor: pointer;
    align-items: center;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    :hover input ~ i {
      background-color: #ffffff;
    }

  }
  i, span {
    display: block;
  }
  i { // checkmark
    flex-shrink: 0;
     margin: 0 10px 0 0;
    height: 20px;
    width: 20px;
    position: relative;
    border: 2px solid #ABBBC7;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    :after { // dot
      content: "";
      // position: absolute;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background: #1E4765;
      display: none;
    }
  }
`;

export interface IRadioButtonsHorizontalProps {
  choices: Array<IRadioButton>;
  onChange: Function;
  selectedRadioButton: string;
}
export interface IRadioButton {
  name: string;
  title: string;
  value: string;
}
export default RadioButtonsHorizontal;
